"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "8.57",
    y: "15",
    width: "6.85",
    height: "0.84",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.07,14.33h.8a1.82,1.82,0,0,1,.44-.27.34.34,0,0,1,0-.08V11.15a.35.35,0,1,1,.71,0v2.75h0a1.75,1.75,0,0,1,1.14.43h.14a1.75,1.75,0,0,1,2.6.35h1.76a.35.35,0,1,0,0-.71H21.88V7.62a.35.35,0,0,0-.35-.35H2.47a.35.35,0,0,0-.35.35V14H.35a.35.35,0,1,0,0,.71H1.86a1.75,1.75,0,0,1,2.6-.35H4.6a1.75,1.75,0,0,1,1.14-.43l.26,0V11.15a.35.35,0,1,1,.71,0v3.06l.17.12h9.2Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "3.33",
    cy: "15.67",
    r: "1.06",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "5.74",
    cy: "15.67",
    r: "1.06",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "18.01",
    cy: "15.67",
    r: "1.06",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "20.42",
    cy: "15.67",
    r: "1.06",
    fill: "#004864"
  }));
};

exports["default"] = _default;